module.exports = __webpack_public_path__ + "img/logo250.08494592.png";